import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { TenantConfigSchema } from "../../_offline/models/tenantConfiguration.schema";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";
import { STANDALONE } from "../../_offline/standalone-data/standalone-data";

@Injectable({
  providedIn: "root"
})
export class TenantConfigurationDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<TenantConfigSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.TENANT_CONFIG.GET_ALL, this.loginUserService.tenantId);
  }

  getAllOnPremise(): Observable<TenantConfigSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.TENANT_CONFIG.GET_ALL, STANDALONE.TENANT_ID);
  }

  putAll(tenantConfigs: TenantConfigSchema[]): Observable<TenantConfigSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.TENANT_CONFIG.PUT_ALL, tenantConfigs);
  }
}
